module.exports = __webpack_public_path__ + "img/arrow_left.07fe8e6c.svg";